import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import ScrollToTop from './ScrollToTop';
import Login from './components/Login/index';
import Signup from './components/Signup';
import HomePage from './components/HomePage';
import LoginPassword from './components/LoginPassword';
import OTPVerification from './components/OTPVerification';
import CraftPage from './components/CraftsPage';
import OtherSection from './components/OtherSection';
import ChoreographyPage from './components/ChoreographyPage';
import DetailChoreographyPage from './components/DetailChoreographyPage';
import Header from './components/Header';
import NavBar from './components/Navbar';
import Carousel from './components/Carousel';
import WishlistPage from './components/WishlistPage';
import NotificationsPage from './components/NotificationsPage';
import Footer from './components/Footer';
import Profile from './components/Profile';
import ProfileUpdate from './components/ProfileUpdate';
import Gallery from './components/Gallery';
import ProtectedRoute from './components/ProtectedRoute';
import SubCategoryUsersPage from './components/SubCategoryUsersPage';
import OtherSectionContentPage from './components/OtherSectionContentPage';
import UsersPage from './components/UsersPage';
import ActorsPage from './components/ActorsPage';
import ActressPage from './components/ActressPage';
import CastingPage from './components/CastingPage';
import UsersProfile from './components/UsersProfile';
import DirectorPage from './components/DirectorPage';
import CraftDetailPage from './components/CraftDetailPage';
import OtherSectionDetailPage from './components/OtherSectionDetailPage';
import InnerDataPage from './components/InnerDataPage';
import MessagesPage from './components/Messages';

// Settings & Support Pages
import SettingsPage from './components/SettingsPage';
import SupportPage from './components/SupportPage';
import PrivacyPolicyPage from './components/PrivacyPolicyPage';
import TermsConditionPage from './components/TermsConditionPage';
import ChangePassword from './components/ChangePassword';
import LandingPage from './components/LandingPage';
import SupportContact from './components/SupportContact';
import Reel from './components/Reel';

function App() {
  const location = useLocation();
  const token = localStorage.getItem('token');
  const isAuthenticated = token !== null && token !== undefined && token !== '';

  // Pages where Header, NavBar, Carousel, and Footer should NOT appear
  const authPages = ['/login', '/login-password', '/signup', '/verify-otp', '/support-contact'];

  // Pages that have embedded Header/NavBar (don't show global Header/NavBar)
  const embeddedHeaderPages = ['/users'];

  const isLandingPage = location.pathname === '/' && !isAuthenticated;

  const showHeaderNavCarousel = !authPages.includes(location.pathname) && !embeddedHeaderPages.includes(location.pathname) && !isLandingPage;

  // Pages where Carousel should NOT appear (but Header and NavBar should)
  const noCarouselPages = ['/', '/detailchoreographypage', '/notification', '/wishlist', '/users', '/followers', '/profile', '/profileupate', '/gallery', '/cast-crew', '/directory', '/casting', '/user-profile', '/director', '/craft-detail', '/subcategory-users', '/other-section-content', '/other-section-detail', '/inner-data', '/settings', '/support', '/privacy-policy', '/terms-conditions', '/change-password', '/messages', '/reels'];

  const showCarousel = showHeaderNavCarousel && !noCarouselPages.includes(location.pathname);

  return (
    <div className="App">
      <ScrollToTop />
      {showHeaderNavCarousel && (
        <>
          <Header />
          <NavBar />
          {showCarousel && <Carousel />}
        </>
      )}
      <Routes>
        {/* Public Routes - No Authentication Required */}
        <Route path="/login" element={isAuthenticated ? <Navigate to="/" replace /> : <Login />} />
        <Route path="/login-password" element={isAuthenticated ? <Navigate to="/" replace /> : <LoginPassword />} />
        <Route path="/signup" element={isAuthenticated ? <Navigate to="/" replace /> : <Signup />} />
        <Route path="/verify-otp" element={isAuthenticated ? <Navigate to="/" replace /> : <OTPVerification />} />
        <Route path="/support-contact" element={<SupportContact />} />

        {/* Protected Routes - Authentication Required */}
        <Route path="/" element={isAuthenticated ? <ProtectedRoute><HomePage /></ProtectedRoute> : <LandingPage />} />
        <Route path="/craft" element={<ProtectedRoute><CraftPage /></ProtectedRoute>} />
        <Route path="/craft-detail" element={<ProtectedRoute><CraftDetailPage /></ProtectedRoute>} />
        <Route path="/other-section" element={<ProtectedRoute><OtherSection /></ProtectedRoute>} />
        <Route path='/choreography' element={<ProtectedRoute><ChoreographyPage /></ProtectedRoute>} />
        <Route path='/detailchoreographypage' element={<ProtectedRoute><DetailChoreographyPage /></ProtectedRoute>} />
        <Route path='/followers' element={<ProtectedRoute><WishlistPage /></ProtectedRoute>} />
        <Route path='/users' element={<ProtectedRoute><UsersPage /></ProtectedRoute>} />
        <Route path='/cast-crew' element={<ProtectedRoute><ActorsPage /></ProtectedRoute>} />
        <Route path='/directory' element={<ProtectedRoute><ActressPage /></ProtectedRoute>} />
        <Route path='/casting' element={<ProtectedRoute><CastingPage /></ProtectedRoute>} />
        <Route path='/director' element={<ProtectedRoute><DirectorPage /></ProtectedRoute>} />
        <Route path='/notification' element={<ProtectedRoute><NotificationsPage /></ProtectedRoute>} />
        <Route path='/messages' element={<ProtectedRoute><MessagesPage /></ProtectedRoute>} />
        <Route path='/reels' element={<ProtectedRoute><Reel /></ProtectedRoute>} />

        <Route path='/profile' element={<ProtectedRoute><Profile /></ProtectedRoute>} />
        <Route path='/profileupate' element={<ProtectedRoute><ProfileUpdate /></ProtectedRoute>} />
        <Route path='/gallery' element={<ProtectedRoute><Gallery /></ProtectedRoute>} />
        <Route path='/subcategory-users' element={<ProtectedRoute><SubCategoryUsersPage /></ProtectedRoute>} />
        <Route path='/other-section-content' element={<ProtectedRoute><OtherSectionContentPage /></ProtectedRoute>} />
        <Route path='/other-section-detail' element={<ProtectedRoute><OtherSectionDetailPage /></ProtectedRoute>} />
        <Route path='/inner-data' element={<ProtectedRoute><InnerDataPage /></ProtectedRoute>} />

        <Route path='/user-profile' element={<ProtectedRoute><UsersProfile /></ProtectedRoute>} />

        {/* Settings & Support Routes */}
        <Route path='/settings' element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
        <Route path='/support' element={<ProtectedRoute><SupportPage /></ProtectedRoute>} />
        <Route path='/privacy-policy' element={<ProtectedRoute><PrivacyPolicyPage /></ProtectedRoute>} />
        <Route path='/terms-conditions' element={<ProtectedRoute><TermsConditionPage /></ProtectedRoute>} />
        <Route path='/change-password' element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} />

      </Routes>
      {(showHeaderNavCarousel || embeddedHeaderPages.includes(location.pathname)) && location.pathname !== '/messages' && location.pathname !== '/reels' && <Footer />}
    </div>
  );
}

export default App;